import classNames from 'classnames'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'

export const renderDecoratedTitle = (text, params) => {
    const {
        style,
        className,
        isRequired = false,
        withLabel = () => {},
    } = params || {}
    return (
        <Translate>
            {(t) => (
                <label
                    style={style}
                    className={classNames(
                        'text-lg font-normal text-color-100 uppercase tracking-wider',
                        className,
                        isRequired && 'required-label'
                    )}
                    {...withLabel({
                        className,
                        isRequired,
                    })}>
                    {t(text)}
                </label>
            )}
        </Translate>
    )
}


export const renderDecoratedLabel = (text, params) => {
    const {
        style,
        className,
        isRequired = false,
        withLabel = () => {},
    } = params || {}
    return (
        <Translate>
            {(t) => (
                <label
                    style={style}
                    className={classNames(
                        'text-sm font-medium text-color-200 tracking-wider pr-3',
                        className,
                        isRequired && 'required-label'
                    )}
                    {...withLabel({
                        className,
                        isRequired,
                    })}>
                    {t(text)}
                </label>
            )}
        </Translate>
    )
}

const FieldDecorator = ({
                            className,
                            label,
                            description,
                            errors,
                            children,
                            isRequired = false,
                            hasError = true,
                            labelProps,
                            renderLabel = renderDecoratedLabel,
                        }) => {
    const t = useTranslate()
    return (
        <div
            className={classNames(
                'ErrorDescription relative space-y-1',
                isRequired && 'required-field',
                {errors},
                className
            )}>

            {_.isString(label) ? (
                    renderLabel(label, {
                        isRequired,
                        className: 'flex capitalize text-sm font-semibold pb-2 block text-color-100',
                        ...(labelProps ?? {}),
                    })
            ) : label}

            {_.isString(description) ? (
                <label className="text-xs block text-color-400 italic">
                    {t(description)}
                </label>
            ) : description}

            {children}

            {hasError && !!_.get(errors, 'message', errors) && (
                <div
                    style={{ marginTop: 5, minHeight: '1em', lineHeight: '1em'}}
                    className="ml-1 text-xs text-red-500 italic">
                    {_.get(errors, 'message', errors)}
                </div>
            )}
        </div>
    )
}

export const FormFieldWrapper = (props) => (
    <FieldDecorator
        labelProps={{
            style: {padding: 0},
        }}
        {...props}
    />
)

export default FieldDecorator
